import i18next from 'i18next';
import { translateLeadLogsOutcome } from '../../../utils/translations';
const useColumnsLeadsLogs = () => {
    return [
        {
            accessor: 'Esito_chiamata__c',
            id: 'Esito_chiamata__c',
            Header: i18next.t('call_outcome'),
            width: 250,
            Cell: ({ row }) => {
                const outcome = row.original.Esito_chiamata__c;
                return (
                    <span>{translateLeadLogsOutcome(outcome)}</span>
                );
            },
        },
        {
            accessor: 'Description',
            id: 'Description',
            Header: i18next.t('description'),
            width: 350,
        },
        {
            accessor: 'LastModifiedDate',
            id: 'LastModifiedDate_date',
            Header: i18next.t('date'),
            width: 250,
            Cell: ({ row }) => {
                const timestamp = row.original.LastModifiedDate;
                const dateObj = new Date(timestamp);
                const date = dateObj.toLocaleDateString('it-IT', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });
                return (
                    <span>{date}</span>
                );
            },
        },
        {
            accessor: 'LastModifiedDate',
            id: 'LastModifiedDate_time',
            Header: i18next.t('hour'),
            width: 220,
            Cell: ({ row }) => {
                const timestamp = row.original.LastModifiedDate;
                const dateObj = new Date(timestamp);
                const hour = dateObj.toLocaleTimeString('it-IT', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                });
                return (
                    <span>{hour}</span>
                );
            },
        },
    ];
};


export default useColumnsLeadsLogs;
